import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-left: 1px solid ${theme.v2.colors.neutral.highMedium};
    position: relative;
    overflow: hidden;
    border-top-right-radius: 24px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      position: absolute;
      left: 0px;
      right: 0px;
    }
  `}
`;

export const Toolbar = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
    min-height: 58px;
    box-sizing: border-box;
  `}
`;

export const ToolbarButton = styled.button`
  ${({ theme, $hideInMobile }) => css`
    display: flex;
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 100%;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    cursor: pointer;
    height: 36px;
    justify-content: center;
    width: 36px;

    ${$hideInMobile && css`
      @media (max-width: ${theme.v2.breakpoints.md}) {
        display: none;
      }
    `}
  `}
`;

export const ChatActions = styled.div`
  display: flex;
  gap: 16px;
`;

export const ContentArea = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
  background-color: ${({ theme }) => theme.v2.colors.neutral.highPure};
`;

export const Iframe = styled.iframe`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    border: none;
    background-color: ${theme.v2.colors.neutral.highPure};
    transform-origin: top left;
    transition: transform 0.2s ease-in-out;
  `}
`;
